import { useForm } from 'react-hook-form';
import { useAlert } from 'shared/components/alerts';
import { useSignDocument } from './use-sign-document';

export const useDocumentDialogSign = (
  documentId: string,
  onClose: () => void,
  contractStartDate: string,
  contractEndDate?: string
) => {
  const formatDate = (value?: string) => (value ? new Date(value).toISOString().slice(0, 10) : '');

  const methods = useForm({
    defaultValues: {
      contractStartDate: formatDate(contractStartDate),
      contractEndDate: formatDate(contractEndDate),
    },
  });

  const mutation = useSignDocument();
  const { alertError } = useAlert();

  const handleSubmit = methods.handleSubmit(() => {
    const contractStartDate = methods.getValues('contractStartDate');
    const contractEndDate = methods.getValues('contractEndDate');

    if (!contractStartDate) {
      return;
    }

    const dto = {
      contractStartDate: contractStartDate,
      contractEndDate: contractEndDate,
    };

    mutation.mutate(
      { documentId, dto },
      {
        onSuccess: onClose,
        onError: (e) => alertError(e),
      }
    );
  });

  return { methods, handleSubmit };
};
